import { render, staticRenderFns } from "./apiCommon.vue?vue&type=template&id=70abcca9&scoped=true&"
import script from "./apiCommon.vue?vue&type=script&lang=js&"
export * from "./apiCommon.vue?vue&type=script&lang=js&"
import style0 from "./apiCommon.vue?vue&type=style&index=0&id=70abcca9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abcca9",
  null
  
)

export default component.exports